export default "__VITE_PUBLIC_ASSET__bca18ec0__"